import clsx from "clsx";

import { Icon } from "../Icon";

type PillPropsTypes = {
  children: React.ReactNode;
  "data-testid"?: string;
  isClosable?: boolean;
  onClick: () => void;
  onClose?: () => void;
};

export default function Pill({
  children,
  isClosable = true,
  onClick,
  onClose,
  "data-testid": dataTestId,
}: PillPropsTypes) {
  return (
    <div
      className="flex cursor-pointer divide-x divide-gray-200 rounded-md bg-white text-xs font-semibold hover:bg-gray-200 transition ease-in"
      data-testid={dataTestId}
    >
      <span
        className={clsx(
          " px-2 py-2 transition ease-in flex items-center",
          isClosable ? "rounded-l-full" : "rounded-full",
        )}
        onClick={onClick}
      >
        {children}
      </span>
      {isClosable && (
        <span
          className="rounded-r-full px-2 py-2 transition ease-in hover:bg-gray-200"
          onClick={onClose}
        >
          <Icon name="xMark" />
        </span>
      )}
    </div>
  );
}
